module.exports = __webpack_public_path__ + "static/media/coinSet.09086c73.png";